import type { FC } from "react";
import { Box, Typography } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import { useTranslation } from "@privacy/translations";
import type { RegistrationStatus } from "../api/registrations.types";
import { statusColors } from "./RegistrationStatus";
import { mergeSx } from "./mergeSx";

export const StatusSquare: FC<{ sx: SxProps<Theme> }> = ({ sx }) => (
  <Box sx={mergeSx({ flexShrink: 0, boxSizing: "border-box", height: "9px", width: "9px", borderRadius: "3px" }, sx)} />
);

export const RegistrationStatusDot: FC<{ status: RegistrationStatus["status"] }> = ({ status }) => (
  <StatusSquare sx={{ bgcolor: statusColors[status].dot }} />
);

export const StatusOptionLabel: FC<{ status: RegistrationStatus["status"] }> = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <RegistrationStatusDot status={status} />
      <Typography
        component="span"
        sx={theme => ({
          mt: "1px",
          fontWeight: 600,
          fontSize: theme.typography.pxToRem(12),
          color: theme.palette.text.secondary,
        })}
      >
        {t(`RegistrationStatus.${status}`)}
      </Typography>
    </Box>
  );
};
